import React from 'react';
import { TasksList } from 'shared/components/ui/tasks-list';
import { useActiveTaskId } from 'shared/contexts/task-detail';
import { useTextFilteredTasks } from 'shared/hooks/use-text-filtered-tasks';
import { QueryParamOptions, useQueryParam } from 'shared/lib/react-router-dom';

import { NoResults } from '../no-results';

export const SearchOverview: React.FC = () => {
  const [searchText] = useQueryParam(QueryParamOptions.Search);
  const tasks = useTextFilteredTasks(searchText ?? '');
  const selectedTask = useActiveTaskId();

  return !!searchText && tasks.length ? (
    <TasksList tasks={tasks} selectedTask={selectedTask} />
  ) : (
    <NoResults />
  );
};
